// Anti-bot email & phone obfuscation
// Contact info is assembled at runtime via JS, never in plain text in HTML source

const _p = ['support', 'telcavoip', 'eu'];
const _w = ['+', '4', '8', ' ', '5', '7', '3', ' ', '1', '8', '7', ' ', '8', '0', '4'];
const _wLink = ['4', '8', '5', '7', '3', '1', '8', '7', '8', '0', '4'];

export const getSupportEmail = () => `${_p[0]}@${_p[1]}.${_p[2]}`;

// Assemble phone at runtime
export const getWhatsAppNumber = () => _w.join('');
export const getWhatsAppLink = () => `https://wa.me/${_wLink.join('')}`;

export const openMailTo = (e) => {
  if (e) e.preventDefault();
  window.location.href = `mai${'lt'}o:${getSupportEmail()}`;
};

export const openWhatsApp = (e) => {
  if (e) e.preventDefault();
  window.open(getWhatsAppLink(), '_blank', 'noopener,noreferrer');
};

export const ObfuscatedEmail = ({ className }) => (
  <span
    className={className || ''}
    onClick={openMailTo}
    role="link"
    tabIndex={0}
    style={{ cursor: 'pointer' }}
  >
    {_p[0]}&#64;{_p[1]}&#46;{_p[2]}
  </span>
);

export const ObfuscatedWhatsApp = ({ className }) => (
  <span
    className={className || ''}
    onClick={openWhatsApp}
    role="link"
    tabIndex={0}
    style={{ cursor: 'pointer' }}
  >
    WhatsApp {_w.slice(0, 3).join('')}{_w.slice(3).join('')}
  </span>
);
